import InputField from "../../../components/InputField";
import OptionalFields from "../../../components/OptionalFields";
import Toggle from "../../../components/Toggle";

export default function ImprumutatorStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <div style={{ width: "100%" }}>
        <Toggle
          label="Persoana juridica"
          description="Imprumutatorul este o firma / societate comerciala"
          checked={!!data.imprumutatorPJ}
          onChange={() => update("imprumutatorPJ")(!data.imprumutatorPJ)}
        />
      </div>

      {data.imprumutatorPJ ? (
        <>
          <InputField label="Denumire societate" value={data.imprumutatorFirma} onChange={update("imprumutatorFirma")} placeholder="ex: SC Exemplu SRL" required error={errors.imprumutatorFirma} />
          <InputField label="CUI" value={data.imprumutatorCUI} onChange={update("imprumutatorCUI")} placeholder="ex: RO12345678" required half error={errors.imprumutatorCUI} />
          <InputField label="Nr. Reg. Comertului" value={data.imprumutatorRegCom} onChange={update("imprumutatorRegCom")} placeholder="ex: J40/1234/2020" half error={errors.imprumutatorRegCom} />
          <InputField label="Sediu social" value={data.imprumutatorSediu} onChange={update("imprumutatorSediu")} placeholder="ex: Str. Exemplu nr. 1, Bucuresti" required error={errors.imprumutatorSediu} />
          <InputField label="Reprezentant legal" value={data.imprumutatorReprezentant} onChange={update("imprumutatorReprezentant")} placeholder="ex: Popescu Ion" required error={errors.imprumutatorReprezentant} />
        </>
      ) : (
        <>
          <InputField label="Nume complet" value={data.imprumutatorNume} onChange={update("imprumutatorNume")} placeholder="ex: Popescu Ion" required error={errors.imprumutatorNume} />
          <InputField label="Adresa de domiciliu" value={data.imprumutatorAdresa} onChange={update("imprumutatorAdresa")} placeholder="ex: Str. Exemplu nr. 1, Bucuresti" required error={errors.imprumutatorAdresa} />
          <OptionalFields>
            <InputField label="CNP" value={data.imprumutatorCNP} onChange={update("imprumutatorCNP")} placeholder="ex: 1234567890123" half error={errors.imprumutatorCNP} helperText="Opțional — poți completa de mână pe document" />
            <InputField label="Serie si nr. CI" value={data.imprumutatorCI} onChange={update("imprumutatorCI")} placeholder="ex: RD 123456" half error={errors.imprumutatorCI} helperText="Opțional — poți completa de mână pe document" />
          </OptionalFields>
        </>
      )}
    </div>
  );
}
